import { OrderDeliveryCategoryType } from "@/types/orders";
import { OrderDeliveryCategoryInterface } from "@/interface/business/order.interface";

/**
 * Delivery Category Class
 */
export default class OrderDeliveryCategory implements OrderDeliveryCategoryInterface {
  id: string = "";
  name: string = "";

  constructor(data: OrderDeliveryCategoryType) {
    Object.assign(this, data);
  }
}
